/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CreateValidationTokenRequest } from '../../models/create-validation-token-request';
import { ValidationTokenModel } from '../../models/validation-token-model';

export interface CreateValidationToken$Plain$Params {
  
    /**
     * properties of validationtoken to create
     */
    body?: CreateValidationTokenRequest
}

export function createValidationToken$Plain(http: HttpClient, rootUrl: string, params?: CreateValidationToken$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<ValidationTokenModel>> {
  const rb = new RequestBuilder(rootUrl, createValidationToken$Plain.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ValidationTokenModel>;
    })
  );
}

createValidationToken$Plain.PATH = '/api/ValidationToken';
